import { Tooltip } from 'primereact/tooltip';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

function ResearchHeading({
  label,
  onOpenAppendModal,
  disabled,
  className,
  tooltipTarget,
  projectRoleId,
  append,
  length,
}) {
  const { t } = useTranslation();

  return (
    <tr className="font-bold">
      <td colSpan={6}>
        <div>
          <span>{t(label)}</span>
          {!disabled && (
            <>
              <i
                onClick={() => {
                  onOpenAppendModal(projectRoleId, append, length);
                }}
                className={`${className} pi pi-plus text-primary cursor-pointer bg-primary p-1 border-circle ml-1`}
                data-pr-tooltip={t('formLayout.action.add')}
                data-pr-position="left"
              />
              {tooltipTarget && <Tooltip target={tooltipTarget} />}
            </>
          )}
        </div>
      </td>
    </tr>
  );
}

export default React.memo(ResearchHeading);

ResearchHeading.propTypes = {
  // eslint-disable-next-line react/require-default-props
  onOpenAppendModal: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  tooltipTarget: PropTypes.string,
  label: PropTypes.string.isRequired,
  projectRoleId: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types, react/require-default-props
  append: PropTypes.any,
  length: PropTypes.number,
};

ResearchHeading.defaultProps = {
  disabled: false,
  className: '',
  tooltipTarget: '',
  projectRoleId: undefined,
  length: 0,
  append: () => {},
};
